/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ domain: NonNullable<unknown> }} Domain_Search_Modal_Is_LiveInputs */

const en_domain_search_modal_is_live = /** @type {(inputs: Domain_Search_Modal_Is_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.domain} is live on your storefront!`)
};

const es_domain_search_modal_is_live = /** @type {(inputs: Domain_Search_Modal_Is_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¡${i?.domain} está activo en tu tienda!`)
};

const fr_domain_search_modal_is_live = /** @type {(inputs: Domain_Search_Modal_Is_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.domain} est en ligne sur votre vitrine !`)
};

const de_domain_search_modal_is_live = /** @type {(inputs: Domain_Search_Modal_Is_LiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.domain} ist in deiner Storefront live!`)
};

/** @type {(inputs: Domain_Search_Modal_Is_LiveInputs) => LocalizedString} */
const ja_domain_search_modal_is_live = en_domain_search_modal_is_live;

/** @type {(inputs: Domain_Search_Modal_Is_LiveInputs) => LocalizedString} */
const zh_domain_search_modal_is_live = en_domain_search_modal_is_live;

/** @type {(inputs: Domain_Search_Modal_Is_LiveInputs) => LocalizedString} */
const ar_domain_search_modal_is_live = en_domain_search_modal_is_live;

/** @type {(inputs: Domain_Search_Modal_Is_LiveInputs) => LocalizedString} */
const id_domain_search_modal_is_live = en_domain_search_modal_is_live;

/** @type {(inputs: Domain_Search_Modal_Is_LiveInputs) => LocalizedString} */
const it_domain_search_modal_is_live = en_domain_search_modal_is_live;

/** @type {(inputs: Domain_Search_Modal_Is_LiveInputs) => LocalizedString} */
const ru_domain_search_modal_is_live = en_domain_search_modal_is_live;

/** @type {(inputs: Domain_Search_Modal_Is_LiveInputs) => LocalizedString} */
const pt_domain_search_modal_is_live = en_domain_search_modal_is_live;

/** @type {(inputs: Domain_Search_Modal_Is_LiveInputs) => LocalizedString} */
const ko_domain_search_modal_is_live = en_domain_search_modal_is_live;

/**
* | output |
* | --- |
* | "{domain} is live on your storefront!" |
*
* @param {Domain_Search_Modal_Is_LiveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_search_modal_is_live = /** @type {((inputs: Domain_Search_Modal_Is_LiveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Search_Modal_Is_LiveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_search_modal_is_live(inputs)
	if (locale === "es") return es_domain_search_modal_is_live(inputs)
	if (locale === "fr") return fr_domain_search_modal_is_live(inputs)
	if (locale === "de") return de_domain_search_modal_is_live(inputs)
	if (locale === "ja") return ja_domain_search_modal_is_live(inputs)
	if (locale === "zh") return zh_domain_search_modal_is_live(inputs)
	if (locale === "ar") return ar_domain_search_modal_is_live(inputs)
	if (locale === "id") return id_domain_search_modal_is_live(inputs)
	if (locale === "it") return it_domain_search_modal_is_live(inputs)
	if (locale === "ru") return ru_domain_search_modal_is_live(inputs)
	if (locale === "pt") return pt_domain_search_modal_is_live(inputs)
	return ko_domain_search_modal_is_live(inputs)
});